const { VUE_APP_SOCKET_URL, VUE_APP_GRAPHQL_ENDPOINT } = process.env;

import Vue from 'vue'

import http from './http'
import router from './router'
import config from './config'
import store from './store'

import VueApollo from 'vue-apollo'
import ApolloClient from 'apollo-boost'

import VueHotkey from 'v-hotkey'
import VueScroll from 'vue-scroll'
import VueResize from 'vue-resize'
import VueCookies from 'vue-cookies'
import VueDebounce from 'vue-debounce';

import VueDayjs from 'vue-dayjs-plugin'


import VueSocketIOExt from 'vue-socket.io-extended'
import { io } from 'socket.io-client';
const socket = io(VUE_APP_SOCKET_URL, {
  autoConnect: false
});

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import 'quill/dist/quill.snow.css';

import 'vue-resize/dist/vue-resize.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(VueHotkey)
Vue.use(VueScroll)
Vue.use(VueResize)
Vue.use(VueCookies)
Vue.use(VueDebounce)

Vue.use(VueApollo);
Vue.use(VueDayjs)

Vue.use(VueSocketIOExt, socket, { store });

const apolloClient = new ApolloClient({
  uri: VUE_APP_GRAPHQL_ENDPOINT,
  request(operation) {
    const token = sessionStorage.getItem('token'); // @TODO

    if (token) {
      operation.setContext({
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    }
  }
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

//
const pluckToken = function() {
  const token = (document.location.search.match(/[?|&]token=([^&]+)/) || [])[1];

  if (token) {
    sessionStorage.setItem('token', token); // @TODO
  }
}

pluckToken();
//

Vue.filter('limit', function limit(string, limit = 30) {
  return string ? string.substr(0, limit) : string;
});

Vue.filter('limitLines', function limit(string, lines = 1) {
  return string ? string.split("\n").slice(0, lines).join('') : string;
});

import keystopper from './mixins/keystopper'

Vue.mixin({
  methods: {
    keystopper
  }
})

import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  http,
  config,
  
  router,
  store,

  apolloProvider,

  render: h => h(App)
}).$mount('#app')
